var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'container',
    {
      'admin-panel-active': _vm.isAdminPanelActive,
      'with-banner': _vm.showAlertBanner,
    } ]},[_c('ConfirmationModal'),_c('OnboardingModal'),_c('ConfirmationProgramClientModal'),_c('WorkoutErrorModal'),_c('ProgramOverrideModal'),_c('ItemSelectModal'),_c('FullsizeImageModal'),_c('SubscriptionClientModal'),_c('NotifyModal'),_c('NavBar'),_c('ClientConfirmationModal'),_c('UnsavedChangesModal',{attrs:{"fromPanel":_vm.isAdminPanelActive}}),_c('DragConfirmationModal'),_c('ImportContactsWizard'),_c('ConfrimEnrollment'),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }